<div class="approval-checks-card" [ngClass]="stateClass">
  <div class="approval-checks-card-inner">
    <div class="card-header">
        <span class="header-label">RECOMMENDED ACTION</span>

        <app-button text="Re-check" faIcon="far fa-rotate" variant="info" size="xs" (clicked)="recheck()" [isBusy]="loading" [disabled]="loading" />
      </div>

      <div class="card-banner" [class.clickable]="totalCount > 0" (click)="totalCount > 0 && openModal()">
        <span class="card-banner-icon">
          <i [class]="stateIcon"></i>
        </span>

        <span>{{ stateText }}</span>
        <i class="far fa-chevron-right banner-chevron" *ngIf="totalCount > 0"></i>
      </div>
  </div>
</div>

<!-- Check Results Modal -->
<div class="checks-modal-backdrop" *ngIf="showModal" (click)="closeModal()">
  <div class="checks-modal" (click)="$event.stopPropagation()">
    <div class="modal-header-row">
      <div>
        <h3>Check Results</h3>
        <p class="modal-subtitle">{{ totalCount }} checks performed &mdash; {{ passedCount }} passed, {{ failedCount }} failed</p>
      </div>
      <button class="modal-close" (click)="closeModal()">&times;</button>
    </div>

    <div class="checks-list">
      <div class="check-item" *ngFor="let check of sortedCheckResults"
        [ngClass]="check.passed ? 'check-passed' : 'check-failed'">
        <div class="check-icon">
          <i *ngIf="check.passed" class="far fa-check-circle"></i>
          <i *ngIf="!check.passed" class="far fa-times-circle"></i>
        </div>
        <div class="check-detail">
          <span class="check-name">
            <i *ngIf="check.isAiCheck" class="far fa-brain-circuit ai-icon"></i>
            {{ check.checkName }}
          </span>
          <span class="check-reason" *ngIf="check.reason">{{ check.reason }}</span>
        </div>
        <span class="check-badge" [ngClass]="check.passed ? 'badge-passed' : 'badge-failed'">
          {{ check.passed ? 'PASSED' : 'FAILED' }}
        </span>
      </div>
    </div>
  </div>
</div>
